import { render, staticRenderFns } from "./main_student.vue?vue&type=template&id=1b8794ac&scoped=true&"
import script from "./main_student.vue?vue&type=script&lang=js&"
export * from "./main_student.vue?vue&type=script&lang=js&"
import style0 from "./main_student.vue?vue&type=style&index=0&id=1b8794ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8794ac",
  null
  
)

export default component.exports